import React from 'react';
import { createRoot } from 'react-dom/client';
import '../scss/chatbot.scss';
import ChatBot from './components/ChatBot';

const DEFAULT_ROOT_ID = 'kapusons-ai-chatbot-root';

const getFrontendConfig = () => {
  if (typeof window === 'undefined') {
    return {};
  }

  return window.KapusonsAiChatbot || {};
};

const resolveReactRoot = () => {
  const config = getFrontendConfig();
  const rootId = config.rootElementId || DEFAULT_ROOT_ID;

  return document.getElementById(rootId);
};

const KapusonsAiChatbotApp = () => {
  return <ChatBot />;
};

const bootstrapReact = () => {
  const rootElement = resolveReactRoot();

  if (!rootElement) {
    console.warn(
      `[Kapusons AI Chatbot] Root element #${DEFAULT_ROOT_ID} non trovato.`
    );
    return;
  }

  if (rootElement.dataset.reactMounted === 'true') {
    return;
  }

  rootElement.dataset.reactMounted = 'true';

  const root = createRoot(rootElement);

  root.render(
    <React.StrictMode>
      <KapusonsAiChatbotApp />
    </React.StrictMode>
  );
};

bootstrapReact();